// extracted by mini-css-extract-plugin
export default {"container":"mod_QPLt1"};